export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manabgu.0d08d5d5.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};